<script setup lang="ts">
import router from '@/router';
import MarkdownIt from 'markdown-it';
import { useRoute } from 'vue-router';

const route = useRoute();

const props = defineProps({
    markdown: {
        type: String,
        default: ''
    },
    newLineToBr: {
        type: Boolean,
        default: false
    },
    openLinksInNewTab: {
        type: Boolean,
        default: true
    },
    linkClicked: {
        type: Function
    }
});

const md = new MarkdownIt({
    breaks: props.newLineToBr
});

async function click(event: MouseEvent): Promise<void> {
    const target = event.target as HTMLElement;

    if (target.tagName == 'A') {
        event.preventDefault();

        const link = target as HTMLAnchorElement;
        if (link.href.startsWith(window.location.origin)) {
            const url = new URL(link.href);
            const resolvedRoute = router.resolve(url.pathname);

            if (!resolvedRoute.name) return;

            if (props.linkClicked) await props.linkClicked();

            if (resolvedRoute.path.split('/')[0] === route.path.split('/')[0]) {
                router.replace(resolvedRoute.path);
            } else {
                router.push(resolvedRoute.path);
            }
        } else {
            window.open(link.href, '_blank');
        }
    }
}
</script>

<template>
    <div @click="click" v-html="md.renderInline(markdown)"></div>
</template>
